module.exports = __webpack_public_path__ + "img/issue-icon-active.0571580b.svg";